/*
 * Created by jmeo at 2021-06-02
 * FileName: index.tsx
 * 协议相关路由
 */

import { Route, Switch, useRouteMatch } from "react-router-dom";

import Authorize from "./pages/Authorize";
import PlatformAgreement from "./pages/PlatformAgreement";
import Entrust from "./pages/Entrust";
import Credit from "./pages/credit";
import CreditCard from "./pages/CreditCard";
import "@assets/style/agreement.scss";
import CreditInvestigation from "./pages/CreditInvestigation";

export default function () {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/auth`} component={Authorize} />
      <Route path={`${path}/credit`} component={CreditInvestigation} />
      <Route path={`${path}/pa`} component={PlatformAgreement} />
      <Route path={`${path}/en`} component={Entrust} />
      <Route path={`${path}/cr`} component={Credit} />
      <Route path={`${path}/information`} component={CreditCard} />
    </Switch>
  );
}
